export function getMaskSize(mask: string): number {
    return mask.replace(/\\(?!\\)/g, '').length;
}

export function isPattern(char: string, patterns: any): boolean {
    for (const key in patterns) {
        if (
            Object.prototype.hasOwnProperty.call(patterns, key) &&
            key === char
        ) {
            return true;
        }
    }
    return false;
}

export function fitToMask(value: string, mask: string, patterns: any): string {
    let modifiedValue = value;
    let newValue = '';

    const size: number = getMaskSize(mask);
    modifiedValue = modifiedValue.substring(0, size);

    for (let i = 0, j = 0; j < mask.length && i < modifiedValue.length; i++, j++) {
        if (mask[j] === '\\') {
            newValue += mask[j + 1];
            j++;
            continue;
        }
        if (isPattern(mask[j], patterns)) {
            if (patterns[mask[j]].test(modifiedValue[i])) {
                newValue += modifiedValue[i];
            } else {
                return newValue;
            }
        } else {
            newValue += mask[j];
            if (mask[j] !== modifiedValue[i]) {
                i--;
            }
        }
    }
    return newValue;
}


export function getValueBySearch(search: string, keyName: string) {
    const query = new URLSearchParams(search);
    const value = query.get(keyName);
    return value;
}

export function getSource(search: string) {
    let source = getValueBySearch(search, 'source');
    if (!source || source === '') {
        source = document.referrer;
    }

    return source;
}

export function getUrlParams(url: string): { [key: string]: string } {
    const params = new URLSearchParams(url);
    const queryParams: { [key: string]: string } = {};

    params.forEach((value, key) => {
        queryParams[key] = value;
    });
    return queryParams;
}
